import * as React from 'react';
import { useLocation, useNavigationType, useMatches } from 'react-router-dom';

const log = false;

export const useLogroutes = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const matches = useMatches();

  if (process.env.NODE_ENV === 'development' && log) {
    React.useEffect(() => {
      console.group('[route change]');
      console.log('action:', navigationType);
      console.log('pathname:', location.pathname);
      console.log('search:', location.search);
      console.log('hash:', location.hash);
      console.log('state:', location.state);
      console.log(
        'matched routes:',
        matches.map((m) => ({
          id: m.id,
          pathname: m.pathname,
        }))
      );
      console.groupEnd();
    }, [location, navigationType, matches]);
  }

  return null;
};
